const state = {
  sidebar: {
    opened: false,
  },
  config: {
    palette: {
      primary: '#1668D3',
      secondary: '#43ced9',
      danger: '#f8706d',
      info: '#004EB9',
      success: '#8ddc88',
      warning: '#ffd652',
      gray: '#8396a5',
      darkerGray: '#5D707F',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
}

const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
}

const actions = {
}

export default {
  state,
  mutations,
  actions,
}
